var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogTemplate',{attrs:{"title":"IMPORTANT MESSAGE","opened":_vm.opened,"onClose":_vm.onClose,"withoutSubmit":""}},[_c('v-card-text',{staticClass:"pa-0 pa-sm-2 text-body-2 text-sm-body-1"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }